import {
    Home,
    Hammer,
    ClipboardCheck,
    FileText,
    MessageCircleMore,
} from 'lucide-react';

const navTabs = [
    { key: 'home', label: 'Home', icon: Home, path: '/', settingsKey: null },
    { key: 'repairs', label: 'Repairs', icon: Hammer, path: '/repairs', settingsKey: 'repairs_enabled' },
    { key: 'tasks', label: 'Requests', icon: ClipboardCheck, path: '/requests', settingsKey: 'requests_enabled' },
    { key: 'documents', label: 'Documents', icon: FileText, path: null, settingsKey: 'document_management_enabled' },
    { key: 'messages', label: 'Messages', icon: MessageCircleMore, path: '/messages', settingsKey: null },
];

export default navTabs;
